"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing = exports.xxl = exports.xl = exports.l = exports.m = exports.s = exports.xs = exports.xxs = exports.xxxs = void 0;
exports.xxxs = '4px';
exports.xxs = '8px';
exports.xs = '16px';
exports.s = '32px';
exports.m = '48px';
exports.l = '64px';
exports.xl = '96px';
exports.xxl = '128px';
exports.spacing = {
    xxxs: exports.xxxs,
    xxs: exports.xxs,
    xs: exports.xs,
    s: exports.s,
    m: exports.m,
    l: exports.l,
    xl: exports.xl,
    xxl: exports.xxl,
};
//# sourceMappingURL=spacing.js.map